/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Related_TitleInputs */

const en_project_related_title = /** @type {(inputs: Project_Related_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More to explore.`)
};

const lv_project_related_title = /** @type {(inputs: Project_Related_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citi darbi, ko apskatīt.`)
};

/**
* | output |
* | --- |
* | "More to explore." |
*
* @param {Project_Related_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const project_related_title = /** @type {((inputs?: Project_Related_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Related_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_project_related_title(inputs)
	return en_project_related_title(inputs)
});